import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  CreateOffensiveDTO,
  OffensiveApiService,
} from 'features/offensive/api/offensive-api.service';

import { offensiveQueryKeys } from './query.keys';

const { createOffensive } = OffensiveApiService();

export const useCreateOffensive = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: CreateOffensiveDTO) => {
      return createOffensive(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: offensiveQueryKeys.all,
        });

        message.success('Offensive successfully Created');
      },
    },
  );
};
